import 'core-js/features/object';

// @ts-ignore missing type
function emptyObject(object): boolean {
  return Object.keys(object).length === 0;
}

export default function sanitizeParams(params: any): any {
  const updatedParams = { ...params };
  Object.entries(updatedParams).forEach(([key, value]) => {
    switch (typeof value) {
      case 'undefined':
        delete updatedParams[key];
        break;
      case 'string':
        if (value.trim().length > 0) {
          updatedParams[key] = value.trim();
        } else {
          delete updatedParams[key];
        }
        break;
      case 'object': // object, array, null
        if (value === null) {
          delete updatedParams[key];
        }
        if (Array.isArray(value)) {
          updatedParams[key] = Object.values(sanitizeParams(value));
        } else {
          updatedParams[key] = sanitizeParams(value);
        }
        if (emptyObject(updatedParams[key])) {
          delete updatedParams[key];
        }
        break;
      default:
        // nothing to do for 'number','boolean'
        break;
    }
  });
  return updatedParams;
}
